import type { ContactScope } from "../components/contacts/ContactScopeToggle";

/**
 * Default-Scope der Kontaktliste (A18, analog `defaultVorgangScope`):
 *  - admin        → „Alle" (Gesamtsicht)
 *  - alle anderen → „Team" (ohne Team-Zugehörigkeit → „Alle" als Fallback,
 *                   da „Persönlich" bei Kontakten oft leer wäre)
 * Ein per Nav-Restore wiederhergestellter Scope hat beim Aufrufer Vorrang.
 */
export function defaultContactScope(isAdmin: boolean, hasTeam: boolean): ContactScope {
  if (isAdmin) return "all";
  return hasTeam ? "team" : "all";
}
